export const uriPrefix = import.meta.env.DEV ? import.meta.env.VITE_SERVER_URI : (window.__env?.SERVER_URI ?? "%SERVER_URI%");
